import type { ApprovalDetail } from './types';

export const approvalFixtures: readonly ApprovalDetail[] = [
  Object.freeze({
    id: 'approval-a',
    partnerId: '00000000-0000-4000-8000-000000000201',
    actionType: 'WALLET_ADJUST',
    entityType: 'AFFILIATE_WALLET',
    entityId: '00000000-0000-4000-8000-000000000301',
    reason: 'Correct duplicate settlement credit',
    evidenceReference: 'case-9001',
    status: 'PENDING',
    requestedBy: '00000000-0000-4000-8000-000000000099',
    requestedAt: '2026-07-20T09:00:00+07:00',
    expiresAt: '2026-07-21T09:00:00+07:00',
    decidedBy: null,
    decidedAt: null,
    decisionReason: null,
    executedAt: null,
    executionReference: null,
  }),
  Object.freeze({
    id: 'approval-b',
    partnerId: '00000000-0000-4000-8000-000000000202',
    actionType: 'WITHDRAWAL_COMPLETE',
    entityType: 'AFFILIATE_WITHDRAWAL',
    entityId: '00000000-0000-4000-8000-000000000401',
    reason: 'Partner confirms credit exists',
    evidenceReference: 'case-9002',
    status: 'APPROVED',
    requestedBy: '00000000-0000-4000-8000-000000000098',
    requestedAt: '2026-07-19T09:00:00+07:00',
    expiresAt: '2026-07-20T09:00:00+07:00',
    decidedBy: '00000000-0000-4000-8000-000000000001',
    decidedAt: '2026-07-19T10:00:00+07:00',
    decisionReason: 'Evidence checks out',
    executedAt: null,
    executionReference: null,
  }),
  Object.freeze({
    id: 'approval-c',
    partnerId: '00000000-0000-4000-8000-000000000203',
    actionType: 'WITHDRAWAL_RELEASE',
    entityType: 'AFFILIATE_WITHDRAWAL',
    entityId: '00000000-0000-4000-8000-000000000402',
    reason: 'Provider confirmed delivery',
    evidenceReference: 'case-9003',
    status: 'EXECUTED',
    requestedBy: '00000000-0000-4000-8000-000000000097',
    requestedAt: '2026-07-18T09:00:00+07:00',
    expiresAt: '2026-07-19T09:00:00+07:00',
    decidedBy: '00000000-0000-4000-8000-000000000001',
    decidedAt: '2026-07-18T10:00:00+07:00',
    decisionReason: 'Evidence checks out',
    executedAt: '2026-07-18T11:00:00+07:00',
    executionReference: 'exec-ref-9003',
  }),
  Object.freeze({
    id: 'approval-d',
    partnerId: '00000000-0000-4000-8000-000000000204',
    actionType: 'PARTNER_CREDIT_PUBLISH',
    entityType: 'PARTNER_CREDIT',
    entityId: null,
    reason: 'Credit terms not yet finalized',
    evidenceReference: 'case-9004',
    status: 'REJECTED',
    requestedBy: '00000000-0000-4000-8000-000000000096',
    requestedAt: '2026-07-17T09:00:00+07:00',
    expiresAt: '2026-07-18T09:00:00+07:00',
    decidedBy: '00000000-0000-4000-8000-000000000001',
    decidedAt: '2026-07-17T10:00:00+07:00',
    decisionReason: 'Terms need revision',
    executedAt: null,
    executionReference: null,
  }),
] as const;
